import { useFormBuilderFieldsContext } from "../../../contexts/FormBuilderFieldsContext.js";
import { InternalContentBadge } from "../../../shared/InternalContentBadge.js";
import "react";
import { Checkbox } from "@therms/atalaya";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/FormBuilder/components/Fields/Checkbox/Form.tsx
var CheckboxFieldForm = ({ config }) => {
	const { errorsByFieldId, fieldValueChanged, valuesByFieldId } = useFormBuilderFieldsContext();
	let value = valuesByFieldId[config.id];
	if (typeof value === "string") value = value.toLowerCase() === "true";
	return /* @__PURE__ */ jsx(Checkbox, {
		active: value,
		error: errorsByFieldId[config.id],
		hint: /* @__PURE__ */ jsxs(Fragment$1, { children: [config.options.required && /* @__PURE__ */ jsx("span", {
			className: "text-color-critical text-sm font-light",
			children: "Required"
		}), config.internal && /* @__PURE__ */ jsx(InternalContentBadge, {})] }),
		label: config.options.label || config.options.formLabel,
		name: config.name,
		onChangeValue: (active) => fieldValueChanged(config.id, active),
		subText: config.options.subText
	});
};
//#endregion
export { CheckboxFieldForm };

//# sourceMappingURL=Form.js.map